import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/zadosti-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.datumPosledniAktivity(),
    COLUMNS_AVAILABLE.zdrojNazev(),
    COLUMNS_AVAILABLE.termin(),
    COLUMNS_AVAILABLE.zadavatelZakaznikNazev(),
    COLUMNS_AVAILABLE.projektNazev(),
    COLUMNS_AVAILABLE.doplnkoveSluzby()
  ];
  return useMemo(() => [columns], []);
}
